import { Expose } from 'class-transformer';

export class OtherPlaceForecast {
  @Expose({ name: 'place_slug' })
  placeSlug: string;

  @Expose({ name: 'place_name' })
  placeName: string;

  @Expose({ name: 'temperature_high' })
  temperatureHigh: number;

  @Expose({ name: 'temperature_low' })
  temperatureLow: number;

  @Expose({ name: 'description' })
  description: string;

  @Expose({ name: 'icon_url' })
  icon: string;
}
